// Was served by CJ v2's GET /customer-journeys/ai-suggestions (its static AI_TYPE
// config), copied verbatim so Campaign App Push no longer depends on CJ v2.

export interface AiSuggestion {
  name: string
  code: string
  params: { parameter_code: string; format: Record<string, string>[] }[]
  options?: { name: string; code: string }[]
  promotionType?: { name: string; code: string }[]
}

const STRING_FORMAT = [
  { format_key: 'lowercase', format_value: 'lowercase' },
  { format_key: 'capitalize_first', format_value: 'Capitalize first' },
  { format_key: 'capitalize_all_first', format_value: 'Capitalize All First' },
  { format_key: 'uppercase', format_value: 'UPPERCASE' },
  { format_key: '', format_value: 'None' },
]

const NUMBER_FORMAT = [
  { format_key: 'pretty_int', description: '10.000', format_value: 'Pretty Int' },
  { format_key: 'pretty_money', description: '10.000đ', format_value: 'Pretty Money' },
  { format_key: 'short_money', description: '10 Nghìn', format_value: 'Short Money' },
  { format_key: 'supper_short_money', description: '10k', format_value: 'Supper Short Money' },
  { format_key: '', description: '', format_value: 'None' },
]

const AI_PRODUCT_PARAMS = [
  { parameter_code: 'ai_product_variant_barcode', format: STRING_FORMAT },
  { parameter_code: 'ai_subject_id', format: STRING_FORMAT },
  { parameter_code: 'ai_product_name', format: STRING_FORMAT },
  { parameter_code: 'ai_cate_lv3', format: STRING_FORMAT },
  { parameter_code: 'ai_emoji', format: STRING_FORMAT },
  { parameter_code: 'ai_headline', format: STRING_FORMAT },
  { parameter_code: 'ai_body', format: STRING_FORMAT },
  { parameter_code: 'ai_discount_price', format: NUMBER_FORMAT },
  { parameter_code: 'ai_price', format: NUMBER_FORMAT },
  { parameter_code: 'ai_discount_percent', format: NUMBER_FORMAT },
  { parameter_code: 'ai_discount_amount', format: NUMBER_FORMAT },
  { parameter_code: 'ai_image', format: STRING_FORMAT },
  { parameter_code: 'ai_large_image', format: STRING_FORMAT },
  { parameter_code: 'ai_inpage_image', format: STRING_FORMAT },
  { parameter_code: 'ai_deeplink_value', format: STRING_FORMAT },
  { parameter_code: 'ai_product_slug', format: STRING_FORMAT },
  { parameter_code: 'ai_cta', format: STRING_FORMAT },
]

const AI_RECIPE_BLOG_PARAMS = [
  { parameter_code: 'ai_headline', format: STRING_FORMAT },
  { parameter_code: 'ai_body', format: STRING_FORMAT },
  { parameter_code: 'ai_cta', format: STRING_FORMAT },
  { parameter_code: 'ai_deeplink_value', format: STRING_FORMAT },
  { parameter_code: 'ai_large_image', format: STRING_FORMAT },
  { parameter_code: 'ai_image', format: STRING_FORMAT },
  { parameter_code: 'ai_inpage_image', format: STRING_FORMAT },
]

export const AI_SUGGESTIONS: AiSuggestion[] = [
  {
    name: 'Reorder Product',
    code: 'reOrderProduct',
    params: AI_PRODUCT_PARAMS,
    options: [
      { name: 'Lv 0', code: 'lv0' },
      { name: 'Lv 1', code: 'lv1' },
      { name: 'Lv 2', code: 'lv2' },
      { name: 'Lv 3', code: 'lv3' },
    ],
    promotionType: [{ name: 'Voucher discount product', code: 'voucher-discount-product' }],
  },
  {
    name: 'Recommend similar product',
    code: 'recommendSimilarProduct',
    params: AI_PRODUCT_PARAMS,
  },
  {
    name: 'Recommend favorite product',
    code: 'recommendFavoriteProduct',
    params: AI_PRODUCT_PARAMS,
    options: [
      { name: 'Lv 0', code: 'lv0' },
      { name: 'Lv 1', code: 'lv1' },
      { name: 'Lv 2', code: 'lv2' },
      { name: 'Lv 3', code: 'lv3' },
    ],
    promotionType: [{ name: 'Voucher discount product', code: 'voucher-discount-product' }],
  },
  {
    name: 'Recommend favorite product (v2)',
    code: 'recommendFavoriteProductV2',
    params: AI_PRODUCT_PARAMS,
    options: [
      { name: 'Lv 1', code: 'lv1' },
      { name: 'Lv 2', code: 'lv2' },
      { name: 'Lv 3', code: 'lv3' },
    ],
    promotionType: [{ name: 'Voucher discount product', code: 'voucher-discount-product' }],
  },
  {
    name: 'Recommended Cart Abandonment Product',
    code: 'recommendedCartAbandonmentProduct',
    params: AI_PRODUCT_PARAMS,
    promotionType: [{ name: 'Voucher discount product', code: 'voucher-discount-product' }],
  },
  {
    name: 'Recommended Cart Abandonment Product (v2)',
    code: 'recommendedCartAbandonmentProductV2',
    params: AI_PRODUCT_PARAMS,
    promotionType: [{ name: 'Voucher discount product', code: 'voucher-discount-product' }],
  },
  {
    name: 'Recommended Cart Abandonment Product (v2.1)',
    code: 'recommendedCartAbandonmentProductV21',
    params: AI_PRODUCT_PARAMS,
    options: [
      { name: 'Lv 1', code: 'lv1' },
      { name: 'Lv 2', code: 'lv2' },
      { name: 'Lv 3', code: 'lv3' },
    ],
    promotionType: [{ name: 'Voucher discount product', code: 'voucher-discount-product' }],
  },
  {
    name: 'Recommend recipe blog',
    code: 'recommendRecipeBlog',
    params: AI_RECIPE_BLOG_PARAMS,
    options: [
      { name: 'Viewed products', code: 'viewedProducts' },
      { name: 'Abandon cart products', code: 'abandonCartProducts' },
      { name: 'purchased products', code: 'purchasedProducts' },
    ],
  },
]
